import React from 'react';
import Footer from '../../../Components/Shared/Footer/Footer';
import Navigation from '../../../Components/Shared/Navigation/Navigation';
import Review from '../../../Components/Shared/Review/Review';
import TopNav from '../../../Components/Shared/TopNav/TopNav';

const ReviewPage = () => {
    return (
        <>
        <TopNav></TopNav>
        <Navigation></Navigation>
        <Review></Review>
        <Footer></Footer>
            
        </>
    );
};

export default ReviewPage;